module.exports = __webpack_public_path__ + "static/media/logo-type-mobismart-white.43027288.png";